var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-alert',{attrs:{"title":_vm.title,"type":"info","show-icon":""}},[_c('el-link',{attrs:{"type":"primary","href":_vm.appendToken,"target":"_blank"}},[_vm._v("Mon Compte ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }